import React, { PureComponent } from 'react'
import { string } from 'prop-types'
import { Button as RButton } from 'reactstrap'
import { Icon } from 'components'

import './IconButton.css'

export class IconButton extends PureComponent {
    static propTypes = {
        className: string,
        iconClassName: string,
        icon: string.isRequired
    }

    render() {
        const { className, icon, iconClassName, ...otherProps } = this.props
        return (
            <RButton className={['IconButton', className]} {...otherProps}>
                <Icon name={icon} className={iconClassName} />
            </RButton>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Buttons/IconButton/IconButton.js